export function Maintenance() {
    return <div className="h-dvh flex flex-col items-center text-4xl">
        <h1 className="pt-[10%]">
            Underhåll pågår
        </h1>
    </div>;
}